import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from './config';


@Injectable({
  providedIn: 'root'
})
export class DiaInhabilService {
  user = [];
  constructor(private http: HttpClient) {
  }

    getData() {
      return this.http.get(config.apiUrl+'/DiaInhabil');
    }

    //Alta
    addData(data:undefined): Observable<any> {
      return this.http.post(config.apiUrl + '/DiaInhabil/', data);
    }

    //Cambio
    updData(id:undefined, data:undefined): Observable<any> {
      return this.http.put(config.apiUrl + '/DiaInhabil/' + id, data);
    } 

}
